exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.array_line {\n  box-shadow: 0px 0px 1px;\n  padding: 5px;\n  margin: 5px;\n}\ndiv.obj_line {\n  border-bottom: dashed 1px #e0c5c5;\n}\n", ""]);

// exports
